import {CommandBase} from '@shared/commands/command-base';
import {Configuration} from '@shared/models/configuration';

export class AddReportCommand extends CommandBase {
  constructor(public title: string, public description: string) {
    super(`${Configuration.getConfig('DataSurveyApi')}Command/AddReport`);
  }

}
export class AddFormReportCommand extends CommandBase {
  constructor(public title: string, public description: string, public id: string) {
    super(`${Configuration.getConfig('DataSurveyApi')}Command/AddFormReport`);
  }
}
export class AddFilingReportCommand extends CommandBase {
  constructor(public title: string, public description: string, public id: string) {
    super(`${Configuration.getConfig('DataSurveyApi')}Command/AddFilingReport`);
  }
}
